import { render, staticRenderFns } from "./EspacoAlegre.vue?vue&type=template&id=80a8ff2c&scoped=true"
import script from "./EspacoAlegre.vue?vue&type=script&lang=js"
export * from "./EspacoAlegre.vue?vue&type=script&lang=js"
import style0 from "./EspacoAlegre.vue?vue&type=style&index=0&id=80a8ff2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a8ff2c",
  null
  
)

export default component.exports